//==================================== production
export const API_ACCOUNT = 'http://103.165.198.187:28080/account'
export const API_MASTER = 'http://103.165.198.187:28080/master'
export const API_ANALYTIC = 'http://103.165.198.187:28080/analytic'
export const MQTT_CONNECT = 'ws://103.165.198.187:15675/ws'
export const MQTT_PORT = '15675'
export const MQTT_HOST = '103.165.198.187'
export const MQTT_PROTOCOL= 'ws'
export const MQTT_USER = 'jpo:jpo'
export const MQTT_PASS = 'rastek@jpo'
export const API_VMS = '103.165.198.186:7878'
export const VMS_URL = '103.165.198.186'
export const VMS_PORT = '7878'
